const TIDY_BATCH = { batchType: 'TIDY', batchDescription: 'Tidy' };

/**
 * Persist tidy position changes via batch or single callbacks.
 */
export function flushTidyPositionChanges(
  positionChanges,
  { skipRecordAction } = {},
  onPositionChangeBatch,
  onPositionChange,
) {
  const batchOpts =
    skipRecordAction !== undefined
      ? { ...TIDY_BATCH, skipRecordAction }
      : TIDY_BATCH;

  if (onPositionChangeBatch && positionChanges.length > 0) {
    onPositionChangeBatch(positionChanges, batchOpts);
  } else if (onPositionChange) {
    positionChanges.forEach(({ taskId, position }) => {
      onPositionChange(taskId, position);
    });
  }
}
